import { render, staticRenderFns } from "./ShipmentOrderDetail.vue?vue&type=template&id=7ba30a44"
import script from "./ShipmentOrderDetail.vue?vue&type=script&lang=js"
export * from "./ShipmentOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports